// "Sunday, May 09, 2021"
export const data1 = [
  {
    room: '152',
    short: '152',
    powerAverage: 0.37,
    estimateKWh: 904
  },
  {
    room: '153',
    short: '153',
    powerAverage: 0.4,
    estimateKWh: 1804
  },
  {
    room: '154',
    short: '154',
    powerAverage: 0.28,
    estimateKWh: 1674
  },
  {
    room: '155',
    short: '155',
    powerAverage: 0.35,
    estimateKWh: 2214
  }
];

// "Sunday, May 16, 2021"
export const data2 = [
  {
    room: '152',
    short: '152',
    powerAverage: 0.34,
    estimateKWh: 1050
  },
  {
    room: '153',
    short: '153',
    powerAverage: 0.42,
    estimateKWh: 1578
  },
  {
    room: '154',
    short: '154',
    powerAverage: 0.25,
    estimateKWh: 2054
  },
  {
    room: '155',
    short: '155',
    powerAverage: 0.32,
    estimateKWh: 2315
  }
];
// "Sunday, May 23, 2021"
export const data3 = [
  {
    room: '152',
    short: '152',
    powerAverage: 0.318360465116279,
    estimateKWh: 994.488863636364
  },
  {
    room: '153',
    short: '153',
    powerAverage: 0.455582348685797,
    estimateKWh: 1652.59229166667
  },
  {
    room: '154',
    short: '154',
    powerAverage: 0.242294117647059,
    estimateKWh: 1951.67534090909
  },
  {
    room: '155',
    short: '155',
    powerAverage: 0.371655172413793,
    estimateKWh: 2392.40269389701
  }
];

// "Sunday, May 30, 2021"
export const data4 = [
  {
    room: '152',
    short: '152',
    powerAverage: 0.330470588235294,
    estimateKWh: 2238.07075
  },
  {
    room: '153',
    short: '153',
    powerAverage: 0.410675990675991,
    estimateKWh: 2454.04571678322
  },
  {
    room: '154',
    short: '154',
    powerAverage: 0.441875,
    estimateKWh: 2816.51125
  },
  {
    room: '155',
    short: '155',
    powerAverage: 0.787588235294118,
    estimateKWh: 5333.842875
  }
];

// "Sunday, June 06, 2021"
export const data5 = [
  {
    room: '152',
    short: '152',
    powerAverage: 0.3733,
    estimateKWh: 1974.1769787234
  },
  {
    room: '153',
    short: '153',
    powerAverage: 0.4905,
    estimateKWh: 2461.11700639786
  },
  {
    room: '154',
    short: '154',
    powerAverage: 0.5096,
    estimateKWh: 1796.92553191489
  },
  {
    room: '155',
    short: '155',
    powerAverage: 0.5354,
    estimateKWh: 2831.95463829787
  }
];
